import { useApp } from '../../contexts/AppContext';

export default function HouseCountSelector() {
  const { config, setActiveHouseCount, houses } = useApp();

  const visibleHouses = houses.filter(house => !house.deactivatedOn);
  const maxHouses = visibleHouses.length;
  const counts = Array.from({ length: maxHouses }, (_, i) => i + 1);

  return (
    <div className="backdrop-blur-lg bg-white/10 rounded-2xl p-6 border border-white/20">
      <h3 className="text-xl font-bold text-white mb-2">Active Houses</h3>
      <p className="text-white/60 text-sm mb-6">
        Select how many houses are active. Reducing the count archives houses (data is preserved).
      </p>

      <div className="flex space-x-3">
        {counts.map(count => (
          <button
            key={count}
            onClick={() => setActiveHouseCount(count)}
            className={`flex-1 py-4 rounded-xl font-bold text-xl transition-all duration-300 ${
              config.activeHouseCount === count
                ? 'bg-gradient-to-r from-yellow-500 to-amber-600 text-white shadow-lg'
                : 'bg-white/5 text-white/60 hover:bg-white/10 hover:text-white'
            }`}
          >
            {count}
          </button>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {visibleHouses.slice(0, maxHouses).map((house, index) => (
          <div
            key={house.id}
            className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm ${
              index < config.activeHouseCount
                ? 'bg-green-500/20 text-green-400'
                : 'bg-white/5 text-white/40'
            }`}
          >
            <span>{house.icon}</span>
            <span>{house.name}</span>
            {index >= config.activeHouseCount && (
              <span className="text-xs opacity-60">(archived)</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
